import wire from '../wire';
import template from './contributors.html';
import contributors from './contributors.js';
class ContributorsController {
  constructor() {
    'ngInject';
    this.contributors = contributors;
  }
}

var module = wire('contributors', template, ContributorsController, 'ContributorsController');

export default module;



// WEBPACK FOOTER //
// ./app/pages/contributors/_index.js